import React from 'react';
import * as ds from './dataService';
import { StyledTextField } from 'modules/components/layer01';
import { FormBaseLayout } from 'modules/components/layer10';
import { SelectRoleField } from 'modules/components/layer04';

export type InviteNonUserFormProps = {
  projectId: string;
  handleClose: () => void;
};

export const FC = (props: InviteNonUserFormProps) => {
  const [
    fnInviteNonUserForm,
    { loading }
  ] = ds.useInviteNonUser();
  const form = ds.useFormState(props.projectId ?? '');
  const handleSubmit = async (data: ds.IFormState) => {

    await fnInviteNonUserForm({
      firstName: data.firstName,
      lastName: data.lastName,
      projectId: data.projectId,
      roleId: data.roleId
    });
    props.handleClose();
  };

  return (
    <FormBaseLayout.FC
      handleCancel={() => props.handleClose()}
      handleSubmit={() => {
        handleSubmit(form.formState);
      }}
      cancelButtonText='Cancel'
      successButtonText='Save'
      isLoading={loading}
    >
      <StyledTextField.FC
        {...form.genFieldProps('firstName')}
      />
      <StyledTextField.FC
        {...form.genFieldProps('lastName')}
      />
      <SelectRoleField.FC
        form={form}
        fieldName='roleId'
        isMultiple={false}
      />
      {/* ADD FIELDS */}
    </FormBaseLayout.FC>

  );
};
